import api from "../interceptors/axios";

async function signout() {
  // SECURITY: Always call signout API to blacklist tokens and clear httpOnly cookie
  // The refresh_token is sent automatically via httpOnly cookie (withCredentials: true)
  // No need to read from Redux state or send in body
  try {
    const response = await api.post(
      `/signout/`, // baseURL is /api, so this becomes /api/api/signout
      {}, // Backend will read refresh_token from httpOnly cookie
      {
        headers: {
          "Content-Type": "application/json",
        },
        withCredentials: true, // Send httpOnly cookie with request
        mode: "cors",
      }
    );

    if (response.status !== 200) {
      throw new Error(response.statusText);
    }

    return response.data;
  } catch (error) {
    console.error("Error during signout:", error);
    // Don't throw - allow logout to proceed even if API call fails
    // This ensures user can logout even if network is down
  }
}

export { signout };
